import styled from 'styled-components';
import { Button } from '@rsos/base-components';

export const ActionButton = styled(Button).attrs({
  btnType: 'tertiary',
  size: 'small',
  noMargin: true,
})`
  width: 48px;
`;
